export default __webpack_public_path__ + "static/media/BlitzscalingAcademyLogo.25cafce0.png";